"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModerationError = void 0;
var react_1 = require("react");
var moderationUtils_1 = require("./moderationUtils");
/**
 * Shared React hook for moderation error state management.
 * Used by both useOracleChatSubscription and useGotsChatSubscription.
 *
 * This hook centralizes all moderation error handling logic so both chat systems
 * (OraclePage and OracleSideGuide) behave identically.
 *
 * @example
 * ```typescript
 * const { moderationError, handleErrorInfo, clearModerationError } = useModerationError()
 *
 * // In subscription onData handler:
 * if (payload.errorInfo?.length > 0) {
 *   if (handleErrorInfo(payload.errorInfo, onModerationError)) {
 *     // Was moderation error - keep pendingMessage visible, skip normal error handling
 *     return
 *   }
 *   // Continue with normal error handling...
 * }
 * ```
 */
var useModerationError = function () {
    var _a = (0, react_1.useState)(null), moderationError = _a[0], setModerationError = _a[1];
    var handleErrorInfo = (0, react_1.useCallback)(function (errorInfo, onModerationError) {
        var error = (0, moderationUtils_1.processModerationError)(errorInfo);
        if (error) {
            setModerationError(error);
            // Fire callback if provided
            if (onModerationError) {
                onModerationError(error.categories, error.config.severity);
            }
            return true; // Was a moderation error
        }
        return false; // Not a moderation error
    }, []);
    var clearModerationError = (0, react_1.useCallback)(function () {
        setModerationError(null);
    }, []);
    return {
        moderationError: moderationError,
        setModerationError: setModerationError,
        handleErrorInfo: handleErrorInfo,
        clearModerationError: clearModerationError,
    };
};
exports.useModerationError = useModerationError;
